import styled from "styled-components";
import { colorsPalettes, mixins, rgba } from "@similarweb/styles";

export const CUSTOM_MODAL_STYLES = {
    content: {
        padding: 0,
        width: 400,
    },
};

export const StyledButtonsInnerContainer = styled.div`
    display: flex;
    flex-grow: 1;
    justify-content: flex-end;

    & > *:not(:last-child) {
        margin-right: 4px;
    }
`;

export const StyledButtonsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
    padding: 16px 0;
`;

export const StyledInput = styled.input`
    cursor: pointer;
`;

export const StyledLabel = styled.label`
    ${mixins.setFontVariant("caption", colorsPalettes.carbon["300"])};
    line-height: 20px;
`;

export const StyledLabelWrap = styled.div`
    margin-bottom: 4px;
`;

export const StyledFieldWrap = styled.div`
    &:not(:last-child) {
        margin-bottom: 12px;
    }

    & ${StyledInput} {
        ${mixins.setFontVariant("input2", colorsPalettes.carbon["400"])};
        border: 1px solid ${colorsPalettes.midnight["50"]};
        border-radius: 3px;
        box-shadow: none;
        display: block;
        height: 40px;
        line-height: 16px;
        margin: 0;
        padding-left: 16px;
        padding-right: 16px;
        width: 100%;

        &:focus {
            border-color: ${colorsPalettes.blue["400"]};
            box-shadow: 0 3px 5px ${rgba(colorsPalettes.carbon["500"], 0.12)};
        }

        &::placeholder {
            color: ${colorsPalettes.carbon["200"]};
        }
    }
`;

export const StyledNameFieldWrap = styled(StyledFieldWrap)`
    margin-top: 32px;
`;

export const StyledFieldsContainer = styled.div`
    margin-top: 12px;
`;

export const StyledSectionTitle = styled.span`
    ${mixins.setFontVariant("body1", colorsPalettes.carbon["400"])};
    line-height: 20px;
`;

export const StyledSection = styled.div`
    margin-top: 32px;
`;

export const StyledDescription = styled.p`
    ${mixins.setFontVariant("body1", colorsPalettes.carbon["400"])};
    line-height: 20px;
    margin: 36px 0 0;
`;

export const StyledModalTitle = styled.h4`
    ${mixins.setFontVariant("h5", colorsPalettes.carbon["500"])};
    line-height: 24px;
    margin: 20px 0 0;
`;

export const StyledModalInner = styled.div`
    padding-left: 24px;
    padding-right: 24px;
`;

export const StyledModalContent = styled.div`
    user-select: none;
`;

export const StyledPrimaryButton = styled.div`
    position: relative;
`;

export const StyledTooltipText = styled.div`
    width: 120px;
    text-align: center;
`;
